import { ITenant } from 'types/queries';
import { IRole } from 'views/backoffice/roles/types';

export enum RoleSelectorMode {
    NONE = 'none',
    SINGLE = 'single',
    MULTIPLE = 'multiple'
}

export type FindTenants = {
    findTenant: UserTenant[];
};

export type FindTenantVariables = {
    data: {
        ids: number[];
    };
};

export type UserTenant = {
    id: string;
    url: string;
    name: string;
    description: string;
};

export type GetUserDetails = {
    getUserDetails: UserLoginDetail[];
};

export type UserLoginDetail = {
    role: Pick<IRole, 'name' | 'description'>;
    tenant: Pick<ITenant, 'id' | 'name' | 'url' | 'description' | 'mfaRequired'>;
};
